import {h, Fragment} from "preact"
export default function SizeCheckbox({ value, selected, onChange, className }) {
    return (
        <label className={`ns-size-checkbox ns-sidebar-filter-locate ${className} ${selected?"selected":""}`} onClick={onChange}>            
            {value}
        </label>
    )
}